import React from "react";
import * as Mui from "@mui/material";
import { ArrowForwardRounded, RuleFolderRounded } from "@mui/icons-material";
import { designColors, designShell } from "services/constants/designTokens";
import { ctaButtonSx, sectionTitleSx } from "./homeUi";

export const RosterPromoBanner = ({
  hasShiftModule,
  navigateToModule,
  loading = false,
}) => (
  <Mui.Box
    sx={{
      ...designShell.sectionCard,
      p: 1.75,
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      justifyContent: "space-between",
      alignItems: { xs: "flex-start", md: "center" },
      gap: 2,
      background: "linear-gradient(90deg, #F8FFFC 0%, #FFFFFF 100%)",
    }}
  >
    {loading ? (
      <>
        <Mui.Stack direction="row" spacing={1.5} alignItems="center" sx={{ flex: 1, minWidth: 0 }}>
          <Mui.Skeleton variant="rounded" width={50} height={50} sx={{ borderRadius: 1.8, flexShrink: 0 }} />
          <Mui.Box sx={{ flex: 1, minWidth: 0 }}>
            <Mui.Skeleton variant="text" width="48%" height={24} />
            <Mui.Skeleton variant="text" width="62%" height={20} />
          </Mui.Box>
        </Mui.Stack>
        <Mui.Skeleton variant="rounded" width={132} height={36} sx={{ borderRadius: 999 }} />
      </>
    ) : (
      <>
        <Mui.Stack direction="row" spacing={1.5} alignItems="center">
          <Mui.Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: 1.8,
              backgroundColor: "#EAFBF1",
              color: "#16A34A",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <RuleFolderRounded sx={{ fontSize: 26 }} />
          </Mui.Box>
          <Mui.Box>
            <Mui.Typography sx={sectionTitleSx}>
              Month-level availability, shift planning and coverage view
            </Mui.Typography>
            <Mui.Typography sx={{ fontSize: 13.5, color: designColors.slate700 }}>
              View your team’s monthly availability in the Roster to plan and manage workforce more effectively.
            </Mui.Typography>
          </Mui.Box>
        </Mui.Stack>
        <Mui.Button
          endIcon={<ArrowForwardRounded />}
          sx={ctaButtonSx}
          onClick={() =>
            navigateToModule(
              hasShiftModule ? "Rosters" : "Reports",
              hasShiftModule ? "view=monthly" : "",
            )
          }
        >
          {hasShiftModule ? "Open Roster" : "Open Reports"}
        </Mui.Button>
      </>
    )}
  </Mui.Box>
);
